import { render, staticRenderFns } from "./SerialDescriber.vue?vue&type=template&id=6703a77c&scoped=true"
import script from "./SerialDescriber.vue?vue&type=script&lang=js"
export * from "./SerialDescriber.vue?vue&type=script&lang=js"
import style0 from "./SerialDescriber.vue?vue&type=style&index=0&id=6703a77c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6703a77c",
  null
  
)

export default component.exports